import styled from '@emotion/styled';
import { LocalizationModelKeys } from '@shared/models/localization/Locales';
import { t } from 'i18next';
import CardStack from '../core/card/CardStack';
import LocalizationLanguageField from './LocalizationLanguageField';

interface ILocalizationFieldProps {
    variant: LocalizationModelKeys;
    value: string;
    onChange: (value: string) => void;
}

function LocalizationFieldCard({ variant, value, onChange }: ILocalizationFieldProps) {
    return (
        <CardStack
            title={t(`common:localization.${variant}.title`)}
            description={t(`common:localization.${variant}.description`)}>
            <TextWrap>
                <LocalizationLanguageField variant={variant} value={value} onChange={onChange} />
            </TextWrap>
        </CardStack>
    );
}

const TextWrap = styled.div`
    padding-top: 2rem;
    width: 100%;
`;

export default LocalizationFieldCard;
